@use '@lib/assets/styles/main.scss' as *;
@use '@lib/components/Typography/TypographyExtends' as *;

.root {
  position: relative;
  &.empty {
    display: inline-block;
    padding-right: 32px;
  }
  &.codeBlock {
    border-radius: 4px;
    border: 1px solid $gray100;
    background: $gray10;
    padding: 2px 36px 2px 4px;
    color: $blue500;
    width: 100%;
    .content {
      @include bodyStyle;
    }
  }
  input {
    display: none;
  }
}

.iconWrap {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  .root.empty & {
    right: 0;
  }
  .root.codeBlock & {
    right: 4px;
  }
}

.icon {
  color: $gray500;
  display: block;
  &:hover {
    color: $gray700;
  }
  &:active {
    color: $gray900;
  }
}
